"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.post.saved': 'Post salvato',
    'socialMediaPlan.post.saveFailed': 'Salvataggio fallito',
    'socialMediaPlan.post.publish': 'Pubblica ora',
    'socialMediaPlan.post.publishedOn': 'Pubblicato su',
    'socialMediaPlan.post.publishFailed': 'Pubblicazione fallita su',
    'socialMediaPlan.post.publishError': 'Pubblicazione fallita. Riprova.',
    'socialMediaPlan.post.duplicated': 'Post duplicato',
    'socialMediaPlan.post.duplicateFailed': 'Duplicazione fallita',
    'socialMediaPlan.post.deleted': 'Post eliminato',
    'socialMediaPlan.post.deleteFailed': 'Eliminazione fallita',
    'socialMediaPlan.post.deleteConfirm': 'Eliminare questo post?',
};
